import requestsByIdsQuery from '../../../../../queries/requestsByIdsQuery';

const { fetch: fetchRequestsByIds } = requestsByIdsQuery;

export const getDataAfterSubmit = async ({ items, requests }) => {
  const failedRequestReasons = new Map();
  const failedData = [];
  const succeededRequestIds = [];

  let updatedRequests;

  items.forEach((el) => {
    const { isSuccess, requestId, reason } = el;

    if (isSuccess) {
      succeededRequestIds.push(requestId);
    } else {
      failedRequestReasons.set(requestId, reason);
      failedData.push(el);
    }
  });

  const failedRequests = requests.reduce((acc, req) => {
    const reason = failedRequestReasons.get(req.id);

    if (reason !== undefined) {
      acc.push({ ...req, reason });
    }

    return acc;
  }, []);

  if (succeededRequestIds.length > 0) {
    updatedRequests = await fetchRequestsByIds(succeededRequestIds, {
      errMsg: 'Не удалось получить список обновленных заявок',
    });
  }

  return { updatedRequests, failedRequests };
};
